export const SEARCH_TYPE_COOKIE = 'search_type_cookie';
export const SEARCH_VIEW_COOKIE = 'search_view_cookie';
export const SEARCH_FILTER_COOKIE = 'search_filter_cookie';
export const NEW_FEATURE_REVISION_COOKIE = 'new_feature_revision_cookie';
export const BOOK_LIVE_DEMO_URL = 'https://info.vulners.com/meetings/andrey-lukashenkov';
export const MOBILE_BREAK_POINT = 600;
export const DESKTOP_BREAK_POINT = 960;
export const NEW_FEATURE_DATA_ATTRIBUTE = 'data-new-feature';
export const emptyArray = [];
export enum SearchType {
    simple = 'simple',
    elastic = 'elastic',
    product = 'product'
}
